import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const ReservedArea = lazy(() => import('../pages/ReservedArea'));
const Home = lazy(() => import('../pages/Home'));
const JsonGenerator = lazy(() => import('../pages/JsonGenerator'));
const Associates = lazy(() => import('../pages/Associates'));
const Feedback = lazy(() => import('../pages/Feedback'));
const Privacy = lazy(() => import('../pages/Privacy'));
const News = lazy(() => import('../pages/News'));

export const createRoutes = (state) => [
  { exact: true, path: '/', element: <Navigate to="/associati" /> },
  { exact: true, path: '/associati', element: <Home /> },
  {
    path: '/associati/documenti',
    exact: true,
    element: <ReservedArea type="documents" />,
  },
  {
    path: '/associati/report',
    exact: true,
    element: <ReservedArea type="reports" />,
  },
  {
    path: '/associati/convenzioni',
    exact: true,
    element: <ReservedArea type="conventions" />,
  },
  {
    path: '/associati/materiale',
    exact: true,
    element: <ReservedArea type="materials" />,
  },
  {
    path: '/associati/news',
    exact: true,
    element: <News />,
  },
  {
    path: '/associati/genera-contenuti',
    exact: true,
    element: <JsonGenerator />,
  },
  {
    path: '/registrati',
    exact: true,
    element: <Associates state={state}/>,
  },
  {
    path: '/associati/feedback',
    exact: true,
    element: <Feedback />,
  },
  {
    path: '/policies/privacy',
    exact: true,
    element: <Privacy />,
  },
];

export default createRoutes;
